/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __extends } from "tslib";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as operations from "./operations";
import { LabServicesClientContext } from "./labServicesClientContext";
var LabServicesClient = /** @class */function (_super) {
  __extends(LabServicesClient, _super);
  /**
   * Initializes a new instance of the LabServicesClient class.
   * @param credentials Credentials needed for the client to connect to Azure.
   * @param subscriptionId The ID of the target subscription.
   * @param [options] The parameter options
   */
  function LabServicesClient(credentials, subscriptionId, options) {
    var _this = _super.call(this, credentials, subscriptionId, options) || this;
    _this.operations = new operations.Operations(_this);
    _this.labPlans = new operations.LabPlans(_this);
    _this.labs = new operations.Labs(_this);
    _this.users = new operations.Users(_this);
    _this.virtualMachines = new operations.VirtualMachines(_this);
    _this.schedules = new operations.Schedules(_this);
    _this.images = new operations.Images(_this);
    _this.operationResults = new operations.OperationResults(_this);
    _this.usages = new operations.Usages(_this);
    _this.skus = new operations.Skus(_this);
    return _this;
  }
  return LabServicesClient;
}(LabServicesClientContext);
// Operation Specifications
export { LabServicesClient, LabServicesClientContext, Models as LabServicesModels, Mappers as LabServicesMappers };
export * from "./operations";